/**
 * Firma muhatapları (#367, sözleşme firm-contacts.md) — `{ name, tel }[]`.
 * Firma Sahibi ve firma telefonu ayrı alanlardır; muhataplar onlara ek.
 * Kurallar sunucudakiyle aynı (modules/firm/domain/firm-contacts.js).
 */

/** Sunucudaki firma modeliyle aynı telefon kuralı (firm.model.js → tel.validate) */
export const FIRM_PHONE_PATTERN = /^[+]?[\d\s()-]{7,20}$/;

export const CONTACTS_MAX = 10;
export const CONTACT_NAME_MAX = 100;

/** Firmadan gelen listeyi form satırlarına çevirir (eksik alan → "") */
export const toContactRows = (contacts) =>
  (Array.isArray(contacts) ? contacts : [])
    .filter((c) => c && (c.name || c.tel))
    .map((c) => ({ name: c.name || "", tel: c.tel || "" }));

/** Gönderilecek liste: kırpılır, adı da telefonu da boş satır atılır */
export const cleanContacts = (rows) =>
  (Array.isArray(rows) ? rows : [])
    .map((c) => ({ name: String(c?.name || "").trim(), tel: String(c?.tel || "").trim() }))
    .filter((c) => c.name || c.tel);

/**
 * Satır başına hata — `{ [index]: { name?, tel? } }`; boş obje = geçerli.
 * Boş satır hata değildir (gönderimde atılır).
 */
export const validateContacts = (rows) => {
  const errors = {};
  (Array.isArray(rows) ? rows : []).forEach((row, i) => {
    const name = String(row?.name || "").trim();
    const tel = String(row?.tel || "").trim();
    if (!name && !tel) return;
    const e = {};
    if (!name) e.name = "Muhatap adı zorunludur";
    if (tel && !FIRM_PHONE_PATTERN.test(tel)) e.tel = "Geçerli bir telefon giriniz";
    if (Object.keys(e).length) errors[i] = e;
  });
  return errors;
};

/** `tel:` bağlantısı için boşluksuz numara */
export const telHref = (tel) => `tel:${String(tel || "").replace(/\s/g, "")}`;
